import { render, staticRenderFns } from "./leave_days_details.vue?vue&type=template&id=0c15d7c2&"
import script from "./leave_days_details.vue?vue&type=script&lang=js&"
export * from "./leave_days_details.vue?vue&type=script&lang=js&"
import style0 from "./leave_days_details.vue?vue&type=style&index=0&id=0c15d7c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports